import { gql } from '@apollo/client';
import { DashboardMetricAnnotationTypeResponse } from '../../queries/dashboard/queryDashboardMetricAnnotations';

export const CREATE_DASHBOARD_METRIC_ANNOTATION = gql`
    mutation CreateDashboardMetricAnnotation($input: CreateDashboardMetricAnnotationInput!) {
        createDashboardMetricAnnotation(input: $input) {
            id
            pageKey
            dateKey
            columnType
            hubId
            metricKey
            dimensions
            content
            createdById
            createdByName
            updatedById
            updatedByName
            createdAt
            updatedAt
        }
    }
`;

export interface CreateDashboardMetricAnnotationInput {
    pageKey: string;
    dateKey: string;
    columnType: string;
    hubId: string;
    metricKey: string;
    dimensions: string;
    content: string;
}

export interface CreateDashboardMetricAnnotationResponse {
    createDashboardMetricAnnotation: DashboardMetricAnnotationTypeResponse;
}

export interface CreateDashboardMetricAnnotationVariables {
    input: CreateDashboardMetricAnnotationInput;
}

export const UPDATE_DASHBOARD_METRIC_ANNOTATION = gql`
    mutation UpdateDashboardMetricAnnotation($input: UpdateDashboardMetricAnnotationInput!) {
        updateDashboardMetricAnnotation(input: $input) {
            id
            pageKey
            dateKey
            columnType
            hubId
            metricKey
            dimensions
            content
            createdById
            createdByName
            updatedById
            updatedByName
            createdAt
            updatedAt
        }
    }
`;

export interface UpdateDashboardMetricAnnotationInput {
    id: string;
    content: string;
}

export interface UpdateDashboardMetricAnnotationResponse {
    updateDashboardMetricAnnotation: DashboardMetricAnnotationTypeResponse | null;
}

export interface UpdateDashboardMetricAnnotationVariables {
    input: UpdateDashboardMetricAnnotationInput;
}

export const DELETE_DASHBOARD_METRIC_ANNOTATION = gql`
    mutation DeleteDashboardMetricAnnotation($id: Long!) {
        deleteDashboardMetricAnnotation(id: $id)
    }
`;

export interface DeleteDashboardMetricAnnotationResponse {
    deleteDashboardMetricAnnotation: boolean;
}

export interface DeleteDashboardMetricAnnotationVariables {
    id: string;
}
